export default __webpack_public_path__ + "static/media/2019 (1).41dbae62.jpg";